export const getFormattedTime = (str) => str.split(':').filter((item, index) => index < 2).join(':');
